module.exports = __webpack_public_path__ + "img/1fie-j-musician.1c7dda94.jpg";